var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading-component',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[(_vm.event != null)?_c('event-page',{key:_vm.event.id,attrs:{"event":_vm.event}}):_c('page-not-found')],1)}
var staticRenderFns = []

export { render, staticRenderFns }